export class Onlineservices {
    intPassUserID: number;
    // passmethodid: number;
    // fromstationid: number;
    // tostationid: number;
    // routeid:number;
    // activationdate: string;
    // passtypeid: number;
    // paymentoption: number;
    // lan: string;
    Username :string="abcd!@#%^&*()_123"; 
    Password :string="s@1_Dx*7s";  
    PaymentModeId :number;  // Pass 10 For PU
    intLocationTypeID :number;  
    intHHTicketCategoryID :number; 
    intPassFrequencyConfigurationID :number; 
    intPassConfigID  :number;
    intFrequencyID  :number;
    intPassTypeID  :number;
    intServiceTypeID :number; 
    intPassMediaID  :number;
    
    productinfo  :string;
    firstname  :string;
    email  :string;
    phone  :string;
    intPaymentGatewayID:number;  //No Need to Pass FRom API
    dtePassActivationDate :Date; 
    dtePassExpiryDate :Date;
    
    udf1: string;
    udf2: string;
    udf3: string;
    udf4: string;
    udf5: string;
    PassDetails:PassDetails_Request[];
    
}
export class PassConfigurationModel
{
    intAmount:string;
    strCityName:string;
    strFrequencyName:string;
}
export class SelectedRoute
{
   
          intRouteID :number;  
          intFromStationID :number;  
          intToStationID :number;  
    
}
export class GetFare
{
     intPassMediaID:number;  
         intPassTypeID :number; 
         intServiceTypeID :number; 
         intHHTicketCategoryID :number; 
         intPassFrequencyID :number; 
       strCityID :string; 
      lstSelRoute :SelectedRoute[]; 
}
export class FareCalculationUnLtd
{
    intRoute_CityID:number;  
    strRoute_CityName :string; 
     decPassFareAmount  :number;
    decTotalFrequencyFare   :number;
    strDiscountUnit  :string; 
   intDiscountValue  :number;
     decPassDiscountedFare   :number;
   intTotalTaxAmount  :number;
   intJourneyFare   :number;      
   intPassIssuanceCharges :number; 
   intPassRenewCharges  :number;
   intNonRefundbleAmount  :number;
   intPassConfigID  :number;
   intMaxCreditJourney  :number;
   intMaxTripsPerDay  :number;
    bUnlimitedTravel :boolean; 
   intPassFrequencyConfigurationID  :number;
   amountHash  :string;
   //lstFareComponementValues;

}
export class FareCalculation
{
    // intRoute_CityID:number;  
    //  strRoute_CityName :string; 
    //   decPassFareAmount  :number;
    //   decTotalFrequencyFare   :number;
    //  strDiscountUnit  :string; 
    // intDiscountValue  :number;
    //   decPassDiscountedFare   :number;
    // intTotalTaxAmount  :number;
    // intJourneyFare   :number;      
    // intPassIssuanceCharges :number; 
    // intPassRenewCharges  :number;
    // intNonRefundbleAmount  :number;
    // intPassConfigID  :number;
    // intMaxCreditJourney  :number;
    // intMaxTripsPerDay  :number;
    //  bUnlimitedTravel :boolean; 
    // intPassFrequencyConfigurationID  :number;
    // //lstFareComponementValues;

    JourneyFare:number;
    RouteName:string;
    JourneyFareDetails:JourneyFareDetailsAVLS[];
}
export class JourneyFareDetailsAVLS
{
    strSelectedRouteID:string;
    intFromStationID:number;
    intToStationID:number;
    strDiscountUnit:number;
    decDiscount:number;
    intTotalAmount:number;
    intMaxCreditJourny:number;
    intMaxTripsPerDay:number;
    bUnlimitedTravel:boolean;
    intFareComponentId:number;
    decTaxValue:number;
    decTotalAppliedTaxAmount:number;
    decAdjustmentAmount:number;
    intMathOperationId:number;
    intPassFareComponentID:number;
    strTaxCalculateIn:string;
    intPassFrequencyConfigurationID:number;
    intPassConfigID:number;
}
export class GetRouteByStation
{
    sourceId:number;
    destinationId:number;
    lan:string;
    usertype:number;
    passMediaId :number;
    passTypeId :number;
    serviceTypeId :number;
    hhTicketCategoryID :number;
    passFrequencyID :number;
}
class AvailablePassDurationReturnResponse
    {
        
        ErrorCode :string;
    }
export class PassDetails_Request    
{
    dteIssueDate :Date;         
    intFromStationID :number; 
    intToStationID  :number;
    strSelectedRouteID :string; 
    intSingleJourneyFare  :number;
    strDiscountUnit :string; 
    decDiscount  :number;
    intTotalAmount  :number;
    intMaxCreditJourny  :number;
    bUnlimitedTravel  :boolean;
    intMaxTripsPerDay  :number;
    intFareComponentId :number;
    decTaxValue  :number;
    decTotalAppliedTaxAmount :number; 
    decAdjustmentAmount  :number;
    intMathOperationId  :number;
    intPassFareComponentID :number; 
    intPassDiscountGroupID :number; 
    strTaxCalculateIn :string;
    intPassConfigID:number;
    intPassFrequencyConfigurationID:number;
}
export class ModelPayment {
    //Send Payment Request Gateway
    passDetails:PassDetailsPayment[];
    strFURL:string;
    strPaymentDetailsHashCode:string;
    strPaymentHashCode:string;
    strSURL:string;
    strVasHashCode:string;
    
}
export class PassDetailsPayment
{
    passReferenceNo:string;
    paymentOrderNo:number;
    qr:string;

}
export class UnltdPassResponse
{
    passFareCalculationValues:FareCalculationUnLtd[];
    ErrorCode:string;
}
export class GetFrequencyByType
{
    Username :string;
    Password :string;
     intPassMediaID:number;
          intPassTypeID :number;
          intServiceTypeID :number;
          intTicketCategoryID :number;
}
export class GetPassHistory
{
    Username:string;
    Password:string;
    intPassUserID:number;
    lan:string;
}
export class GetPassHistoryData
{
    intPassUserID :number;
    PaymentOrderNo :number;
     PassReferenceNo :number;
     strServiceType :string;
     dteIssueDate : Date;    
     dteCurrentServerDate:Date; 
     dtePassActivationDate :Date;
     dtePassExpiryDate :Date;
     PassAmount :number;
    isExpired : boolean;  
     strFromStation :string;
     strToStation :string;
     strPassValidRoutes :string;
     strPassengerCategory :string;
    intPassTypeID :number;
    intFrequencyID :number;
     strPassType :string;
     strPassFrequency :string;
     strPaymentStatus :string;
    intAllowedMaxTripsPerDay :number;
    intTotalCountPassUsedToday :number;
     QR :string;
    isActivationDateStarted :boolean;
}
export class PasssListByMobile
{
    intPassIssuanceID :number;
    intIssuerID :number;
    dtePassActivationDate :string;
    dtePassExpiryDate :string;
}
export class PassDetailsByPassNo
{
    intPassIssuanceID :number;
    intFrequencyID :number;
    intPassTypeID :number;
    intFromStationID :number;
    intToStationID :number;
    strMobileNo :string;
    dtePassExpiryDate :string;
    strFullName :string;
    strFrequencyName :string;
    strPassType :string;
    isExpired:boolean;
}
export class InsertPassRenew {
    intPassUserID: number;
    Username :string="abcd!@#%^&*()_123"; 
    Password :string="s@1_Dx*7s";  
    PaymentModeId :number;  // Pass 10 For PU
    intLocationTypeID :number;  
    intHHTicketCategoryID :number; 
    intPassFrequencyConfigurationID :number; 
    intPassConfigID  :number;
    intFrequencyID  :number;
    intPassTypeID  :number;
    intServiceTypeID :number; 
    intPassMediaID  :number;
    
    productinfo  :string;
    firstname  :string;
    email  :string;
    phone  :string;
    intPaymentGatewayID:number;  //No Need to Pass FRom API
    dtePassActivationDate :Date; 
    dtePassRenewExpiryDate :Date;
    
    udf1: string;
    udf2: string;
    udf3: string;
    udf4: string;
    udf5: string;
    PassDetails:PassDetails_Request[];
    intParentPassIssuanceID:number;
}
export class InsertPassNew{
    Username :string="abcd!@#%^&*()_123"; 
    Password :string="s@1_Dx*7s"; 
        PaymentModeId:number; // Pass 10 For PU
        productinfo:string;
        firstname:string;
        email:string;
        udf1:string;
        udf2:string;
        udf3:string;
        udf4:string;
        udf5:string;

        intHHTicketCategoryID:number;

        intFrequencyID:number;
        intPassTypeID:number;
        intServiceTypeID:number;
        intPassMediaID:number;
        intPassUserID:number;
        intLocationTypeID: number;// 7	Mobile Android, 8	Mobile IPhone, 9	WebPortal
        dtePassActivationDate:Date;
        dtePassExpiryDate:Date;
        phone:string;
        intPaymentGatewayID:number;//No Need to Pass FRom API
        jsonPassDetails:string;
        PassDetails:PassDetails_Request[];
        //PassHash:
        strProfileImg:string;
        strBonafiedImg:string;
        strBonafiedEffectiveDate:string;
}
